import type { DataLayerInfo, PageInfo } from '../../../../shared/types'

export const getCampaignsPetitionSubVerticalDataLayer = (pageInfo: PageInfo) => {
  const campaignsPetitionDataLayer: DataLayerInfo = {
    ...pageInfo,
    topicName: pageInfo.sub_vertical,
    content_type: 'campaigns',
  }

  delete campaignsPetitionDataLayer.sub_vertical

  return campaignsPetitionDataLayer
}
